import {
  Text,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Textarea,
  RadioGroup,
  Radio,
  Box,
} from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector, useAppDispatch } from 'hooks';
import {
  setUnderwritingApprovalRequired,
  setUnderwritingReason,
  useLegacyAutoFormLocked,
} from 'reducers/legacyAutoFormReducer';

const UnderwritingSection = () => {
  const dispatch = useAppDispatch();
  const isLocked = useLegacyAutoFormLocked();

  const underwritingApprovalRequired = useAppSelector(
    (state) => state.legacyAutoForm.data.additional_info.underwriting_approval_required,
  );
  const underwritingReason = useAppSelector(
    (state) => state.legacyAutoForm.data.additional_info.underwriting_reason,
  );

  const handleApprovalRequiredChange = (value: string) => {
    dispatch(setUnderwritingApprovalRequired(value === 'yes'));
  };

  const handleReasonChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    dispatch(setUnderwritingReason(event.target.value));
  };

  return (
    <Card mb="20px" id="sectionUnderwriting">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Underwriting
      </Text>

      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel ml="0">Underwriting Approval Required?</FormLabel>
          <RadioGroup
            value={underwritingApprovalRequired ? 'yes' : 'no'}
            onChange={handleApprovalRequiredChange}
            isDisabled={isLocked}
          >
            <HStack spacing={8}>
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </HStack>
          </RadioGroup>
        </FormControl>

        {underwritingApprovalRequired && (
          <Box p={4} borderWidth="1px" borderRadius="md" borderColor="gray.200">
            <FormControl>
              <FormLabel ml="0">Reason for Underwriting Approval</FormLabel>
              <Textarea
                value={underwritingReason}
                onChange={handleReasonChange}
                placeholder="Enter reason for underwriting approval..."
                rows={4}
                isDisabled={isLocked}
              />
            </FormControl>
          </Box>
        )}
      </VStack>
    </Card>
  );
};

export default UnderwritingSection;
